var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.page.list,
            "header-cell-style": {
              "text-align": "center",
              background: "#F8F8F9",
              color: "#333333",
            },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "时间", width: "200" },
          }),
          _c("el-table-column", {
            attrs: { prop: "orderNo", label: "订单编号", width: "220" },
          }),
          _c("el-table-column", {
            attrs: { prop: "address", label: "商品" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.goodsInfoList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { "text-align": "left" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                display: "-webkit-box",
                                "-webkit-box-orient": "vertical",
                                "-webkit-line-clamp": "2",
                                "text-overflow": "ellipsis",
                                overflow: "hidden",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.goodsName) + " ")]
                          ),
                          _c("div", [
                            _vm._v(
                              _vm._s(item.skuName) + "*" + _vm._s(item.num)
                            ),
                          ]),
                        ]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "typeLabel", label: "类型", width: "200" },
          }),
          _c("el-table-column", {
            attrs: { prop: "num", label: "积分金额", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(Number(scope.row.num).toFixed(2)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "statusLabel", label: "状态", width: "200" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { float: "right", "margin-top": "20px" } },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page.currentPage,
              "page-sizes": [5, 10, 20, 30, 50],
              "page-size": _vm.page.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.page.totalNum,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }